import { useLanguage } from '@/contexts/LanguageContext';
import { SupportedLocale } from '@/types/supported-locale.type';
import { useState } from 'react';

export const useResourceLanguage = () => {
  const { currentLanguage } = useLanguage();

  const [language, setLanguage] = useState<SupportedLocale>(
    currentLanguage.slice(0, 2) as SupportedLocale,
  );

  return { language, setLanguage };
};
